enum SettlementRecipientType {
  Everyone = 'Everyone',
  OwnersWithDebitBalance = 'OwnersWithDebitBalance',
  OwnersWithCreditBalance = 'OwnersWithCreditBalance'
}

export default SettlementRecipientType;
